export function fetch() { return { type: 'AGE_GROUPS/FETCH' } }
export function fetchTournamentSeasons() { return { type: 'TOURNAMENT_SEASONS/FETCH' } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/ageGroups.js